import { IconCheck } from "@/assets/icons";
import { TRenewVisaUploadFileForm } from "@/features/renew-visa/types/renewVisaUploadFileForm";
import { background, divider, state } from "@/theme/colors";
import { css, Stack, styled, Typography } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type TGroupSixFileBoxInputProps = {
  title: string;
  control: Control<TRenewVisaUploadFileForm>;
  name: keyof TRenewVisaUploadFileForm;
  filePath?: string;
  readonly?: boolean;
  required?: boolean;
};

export const GroupSixFileBoxInput: FC<TGroupSixFileBoxInputProps> = ({ title, filePath }) => {
  const isUploaded = !!filePath;
  return (
    <Stack flexDirection="row" alignItems="center" gap={2} padding={2} sx={{ border: "1px solid #E6E7E8", borderRadius: "8px" }}>
      <Stack
        alignItems="center"
        justifyContent="center"
        width={16}
        height={16}
        borderRadius={16}
        bgcolor={isUploaded ? state.success_1 : divider.middle}
      >
        <IconCheck color={background.white} />
      </Stack>
      <TitleWrapper variant="sub16Semi" width={820}>
        {title}
      </TitleWrapper>
    </Stack>
  );
};

const options = { shouldForwardProp: (propName: string) => !["downloadable"].includes(propName) };

const FileItemDownload = css`
  cursor: pointer;
  color: ${state.link_1};
  :hover {
    color: ${state.link_2};
  }
`;

const TitleWrapper = styled(Typography, options)<{ downloadable?: boolean | null }>`
  ${({ downloadable }) => downloadable && FileItemDownload}
`;
